@use "../../styles/breakpoint.module.scss" as *;

$below-small: "max-width: 480px";

.container {
    composes: grid from "../../styles/layout.module.scss";
    grid-column: 1 / -1;
}

.grid {
    grid-column: content;
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacer-40);
    justify-content: center;

    > * {
        flex: 0 0 auto;
    }

    &[data-columns="2"] {
        max-width: calc(
            2 * (100% - 3 * var(--spacer-40)) / 4 + var(--spacer-40)
        );
        margin-inline: auto;
    }

    &[data-columns="2"] > * {
        width: calc((100% - var(--spacer-40)) / 2);
    }

    &[data-columns="3"] {
        max-width: calc(
            3 * (100% - 3 * var(--spacer-40)) / 4 + 2 * var(--spacer-40)
        );
        margin-inline: auto;
    }

    &[data-columns="3"] > * {
        width: calc((100% - 2 * var(--spacer-40)) / 3);
    }

    &[data-columns="4"] > * {
        width: calc((100% - 3 * var(--spacer-40)) / 4);
    }

    @media ($below-tablet) {
        &[data-columns="2"],
        &[data-columns="3"],
        &[data-columns="4"] {
            max-width: none;
            margin-inline: unset;
        }

        &[data-columns="2"] > *,
        &[data-columns="3"] > *,
        &[data-columns="4"] > * {
            width: calc((100% - var(--spacer-40)) / 2);
        }
    }

    @media ($below-small) {
        padding: 0 var(--spacer-24);

        &[data-columns="2"] > *,
        &[data-columns="3"] > *,
        &[data-columns="4"] > * {
            width: 100%;
        }
    }
}
